export const CSBPlusBannerEndDate = '2027-01-01 06:00:00';
export const CSBPlusReportEndDate = '2024-12-31 06:00:00';
export const BBBActivationStartDate = '2024-07-01 06:00:00';
export const BBBActivationEndDate = '2024-10-01 06:00:00';
export const BBBBannerEndDate = '2024-12-01 06:00:00';
export const DoubleDoubleStartDate = '2025-07-01 06:00:00';
export const DoubleDoubleEndDate = '2026-01-01 06:00:00';
